import { styled } from '../../Utilities';
import { IconBase } from './Icon.base';
import { getStyles } from './Icon.styles';
/**
 * Icons are used for rendering an individual's avatar, presence and details.
 * They are used within the PeoplePicker components.
 */
export var Icon = styled(IconBase, getStyles, undefined, { scope: 'Icon' });
//# sourceMappingURL=Icon.js.map